import { Button, ButtonProps } from "@kaltura/ds-react-components";
import { useRef, useState } from "react";
import { translate } from "@kaltura/mediaspace-shared-utils";

export interface CopyButtonProps extends ButtonProps {
    copyText: string;
}

/**
 * A button that copies given text
 */
export const CopyButton = ({ children, copyText, ...props }: CopyButtonProps) => {
    const [copied, setCopied] = useState(false);
    const timeoutRef = useRef<ReturnType<typeof setTimeout>>(null);

    const handleCopy = () => {
        void window.navigator.clipboard.writeText(copyText);
        setCopied(true);
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => setCopied(false), 1000);
    };

    return (
        <Button {...props} onClick={handleCopy}>
            {copied ? translate("Copied") : children}
        </Button>
    );
};
